/*
 * @Author: Liux
 * @Date: 2019-09-27 02:14:38
 * @LastEditor: Liux
 * @LastEditTime: 2019-09-29 02:11:00
 */
import { Injectable, EventEmitter } from '@angular/core';
import { AdDashboardBoxButton } from './ad-dashboard-box/ad-dashboard-box.component';
import { AdDashboarxBoxSize } from './ad-dashboard-box/ad-dashboard-box.component';

@Injectable()
export class AdDashboardWidgetEventService {
  constructor() {}

  public onResize: EventEmitter<AdDashboarxBoxSize> = new EventEmitter();
  public onSettingChange: EventEmitter<any> = new EventEmitter();
  public onLoading: EventEmitter<boolean> = new EventEmitter();
  public onRightHeaderTemplateChange: EventEmitter<any> = new EventEmitter();
  public onRightButtonChange: EventEmitter<
    AdDashboardBoxButton[]
  > = new EventEmitter();
}
